import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import cx from 'classnames'

import { Socials } from '../socials'

import { articleList, publicationList } from './data'

import styles from './style.module.scss'

interface Props {
	socialsShow: boolean
}

export const View = ({ socialsShow }: Props) => {
	return (
		<Section fullWidth className={styles.wrapper}>
			<h2 className={styles.h2}>Готовим статьи, которые помогают в работе</h2>

			<div className={styles.content}>
				<div className={styles.articles}>
					{articleList.map((article, index) => (
						<a
							href={article.href}
							target='_blank'
							rel='noopener noreferrer nofollow'
							role='article'
							key={index}
							className={styles.article}
						>
							<div className={styles.articleImage}>
								<Image alt={article.title} name={article.imageSrc} />
							</div>
							<div className={styles.articleContent}>
								<span className={styles.articleTag}>{article.tag}</span>
								<p className={styles.articleTitle}>{article.title}</p>
								<span className={styles.articleDate}>{article.date}</span>
							</div>
						</a>
					))}
				</div>
				<aside className={styles.aside}>
					<h3 className={styles.asideTitle}>Публикуемся в экспертном журнале ЭБК system</h3>
					<div className={styles.asideContent}>
						{publicationList.map(({ href, title }, index) => (
							<a
								key={index}
								href={href}
								target='_blank'
								rel='noopener noreferrer nofollow'
								className={styles.publication}
							>
								{title} &#8594;
							</a>
						))}
					</div>
				</aside>
				{socialsShow && <Socials />}
				<div className={cx(styles.show, !socialsShow && styles.showNoSocial)}>
					<div className={styles.showContent}>
						<h2 className={styles.showContentTitle}>
							Запустили первое шоу <br /> в России про кредитных брокеров
						</h2>
						<h3 className={styles.showContentSubtitle}>
							«А брокер кто?» — первое шоу в России про кредитных брокеров. В нём мы приглашаем
							профессионалов и задаём им вопросы про карьеру, деньги и ошибки.{' '}
						</h3>
						<p className={styles.showContentText}>
							Герой выпуска Никита Кольцын — кредитный брокер, который помогает предпринимателям
							получать кредиты на десятки миллионов рублей. Он знает, как донести до клиентов
							ценность работы брокера и обосновать стоимость своих услуг — даже если она выше
							рыночной.
						</p>
						<a
							href={
								'https://www.youtube.com/watch?v=P0c5YlkIyRs&ab_channel=%D0%9F%D1%80%D0%BE%D0%BA%D1%80%D0%B5%D0%B4%D0%B8%D1%82%D1%8B%D0%B8%D0%B8%D0%BD%D0%B2%D0%B5%D1%81%D1%82%D0%B8%D1%86%D0%B8%D0%B8%E2%80%94CreditClub'
							}
							target='_blank'
							rel='noopener noreferrer nofollow'
							role='show'
							className={styles.showContentLink}
						>
							Cмотреть шоу на YouTube
						</a>
					</div>
					<div className={styles.showImages}>
						<div className={styles.showImagesInterview}>
							<Image lazy name={'youtube_interview.png'} />
						</div>
					</div>
				</div>
			</div>
		</Section>
	)
}
